export const TRANSLATION_SCOPE = 'settingsLicenseModule';
export const TRANSLATION_LICENSE_SCOPE = [TRANSLATION_SCOPE, 'license'];
